// Workspace review shortcuts for the Shortcuts dialog: list movement, centre views, highlights, Review ↔ Matrix, ask, copy link and list search.
import type { ShortcutDef } from "@/app/shortcuts";

export const WORKSPACE_SHORTCUTS: readonly ShortcutDef[] = [
  { id: "workspace-move", keys: [["↓"], ["↑"], ["J"], ["K"]], description: "Next or previous requirement" },
  { id: "workspace-views", keys: [["1"], ["2"], ["3"]], description: "Source, curve or split view" },
  { id: "workspace-highlights", keys: [["H"]], description: "Show or hide highlights" },
  { id: "workspace-matrix", keys: [["M"]], description: "Switch between review and matrix" },
  { id: "workspace-ask", keys: [["A"]], description: "Ask the assistant about this requirement" },
  { id: "workspace-copy", keys: [["C"]], description: "Copy a link to this requirement" },
  { id: "workspace-search", keys: [["/"]], description: "Search the requirement list" },
];
